import Classes from './_classes';
import Interfaces from './_interfaces';
import * as AutoComplete from './_autocomplete';

export namespace Modal {
    const saveButtonId: string = '#form-modal-save';

    // Display a confirmation window
    // Currently uses the build-in confirm window, but should be replaced by a window with decent design
    export function showConfirmationWindow(text: string) {
        return confirm(text);
    }

    export type ConfirmWindowCallback = () => void;

    export function showConfirmationWindowAsync(text: string, title: string, onAcceptCallback: ConfirmWindowCallback, onRejectCallback: ConfirmWindowCallback, acceptButtonText: string, rejectButtonText: string) {
        title = title || "Figyelem!";
        acceptButtonText = acceptButtonText || "Igen";
        rejectButtonText = rejectButtonText || "Mégsem";

        $('#generic-modal-confirm #confirm-modal-title').html(title);
        $('#generic-modal-confirm #confirm-modal-text').html(text);
        $('#generic-modal-confirm #confirm-modal-accept-button').html(acceptButtonText);
        $('#generic-modal-confirm #confirm-modal-reject-button').html(rejectButtonText);

        let closedByAcceptButton: boolean = false;

        $('#generic-modal-confirm').off('hidden.bs.modal').on('hidden.bs.modal', (e) => {
            if (!closedByAcceptButton && onRejectCallback) {
                onRejectCallback();

                return;
            }

            if (onAcceptCallback) {
                onAcceptCallback();
            }
        });

        $('#generic-modal-confirm #confirm-modal-accept-button').off('click').on('click', (e) => {
            closedByAcceptButton = true;
        });

        $('#generic-modal-confirm').off('shown.bs.modal').on('shown.bs.modal', (e) => {
            $('#generic-modal-confirm #confirm-modal-accept-button').focus();
        });

        $('#generic-modal-confirm').modal('show');
    }

    export function showAlertWindow(text: string | string[], title: string, acceptButtonText: string = null, showCloseButton: boolean = true, callback: JQuery.EventHandler<HTMLButtonElement> = null) {

        title = title || "Figyelem!";
        acceptButtonText = acceptButtonText || "Bezárás";

        var $title = $('#generic-modal-alert #alert-modal-title');
        var $content = $('#generic-modal-alert #alert-modal-text');
        var $acceptButton = $('#alert-modal-accept-button') as JQuery<HTMLButtonElement>;
        var $closeButton = $('#alert-modal-close-button') as JQuery<HTMLButtonElement>;

        $title.html(title);

        let text2 = (text instanceof Array) ? text.join('<br />') : text;
        $content.html(text2);

        $('#generic-modal-alert').off('shown.bs.modal').on('shown.bs.modal', function () {
            $acceptButton.focus();
        })

        if (showCloseButton) {
            $closeButton.show();
        } else {
            $closeButton.hide();
        }

        $acceptButton.off('click');
        if (callback) {
            $acceptButton.on('click', callback);
        }

        $acceptButton.html(acceptButtonText);

        $('#generic-modal-alert').modal({
            keyboard: showCloseButton
        });
    }

    /**
     * Display a Bootstrap popup with dynamic content. The content is downloaded via an ajax call (contentUrl). First, the modal window is displayed containing a loading indicator. It is then replaced by the content once it arrives.
     * Optionally, it supports posting back to a different url (the saveUrl parameter). This requires that the content contains a form.
     * @param settings
     */
    export function showBootstrapModalWithAjaxContent(settings: Classes.BootstrapModalWithAjaxContentSettings): void {

        let $elem = $('#generic-modal-form');
        let $title = $elem.find("#form-modal-title");
        let $content = $elem.find("#form-modal-content");
        let $rejectButton = $('#form-modal-reject');
        let $saveButton = $(saveButtonId);
        let $infoWrapper = $('#form-modal-info');
        let $errorWrapper = $('#form-modal-error');

        $saveButton.removeAttr('disabled'); 

        let enableClientSideValidation = settings.enableUnobtrusiveValidation;

        // Reset the content
        let title: string = `${settings.title} ${createInfoIcon()}`;
        $title.html(title);
        $saveButton.html(settings.saveText);
        $content.html('');
        $content.html(
            `<div class="spinner-border align-self-center" role="status">
                <span class= "sr-only" > Loading...</span>
            </div>`);
        $infoWrapper.hide();
        $errorWrapper.hide();

        if (!settings.showRejectButton) {
            $rejectButton.hide();
        }

        if (!settings.showSaveButton) {
            $saveButton.hide();
        } else {
            $saveButton.show();
        }

        // Load the content of the form
        $elem.off('show.bs.modal').on('show.bs.modal', () => {
            if (settings.infoText) {
                $infoWrapper.show().text(settings.infoText);
            }

            if (settings.contentUrl) {  
                $.ajaxSetup({
                    'headers': {
                        'accept': 'application/json'
                    }
                });

                $content.load(settings.contentUrl, null, (response: string, textStatus: JQuery.Ajax.TextStatus, jqXHR: JQueryXHR) => {

                    if (textStatus != 'error') {
                        if (settings.enableUnobtrusiveValidation) {
                            parseUnobtrusiveValidatorRules('#form-modal-content', (event, validators) => {
                                $errorWrapper.empty();

                                $errorWrapper.find('.data-validation-error-message').remove();

                                if (validators.errorList.length) {
                                    $.each(validators.errorList, () => {
                                        let error = $('<p class="data-validation-error-message"></p>').html(this.message);
                                        $errorWrapper.append(error);
                                    });
                                }

                                if ($errorWrapper.length && !settings.enableUnobtrusiveValidation) {
                                    $errorWrapper.show();
                                } else {
                                    $errorWrapper.hide();
                                }
                            });
                        }

                        // Also handle the enter keypress to submit the form
                        $content.find('form').keypress((event) => {
                            if (event.keyCode === 13 && settings.canSaveUsingEnterKey) {
                                event.preventDefault();

                                sendForm();
                            }
                        });

                        // Try to focus the first input field, hoping for the best
                        $content.find('form input:not(:hidden):first').trigger('focus');

                        // Have to fire datepicker init when modal content is ready.
                        $(document).trigger('DatePickerInit');

                        AutoComplete.InitAutocompletes();
                    } else {
                        const responseJson: Interfaces.EphatFilterResponse = JSON.parse(jqXHR.responseText);
                        const errorText: string = `${responseJson.message} Hibakód: ${responseJson.errorId}`;

                        $errorWrapper.empty();
                        $errorWrapper.append(errorText);
                        $content.html('');
                        $errorWrapper.show();

                        $(document).trigger('DatePickerInit');
                    }
            });
            }
        });

        // When saving, we need to POST an ajax request
        $saveButton.off('click').on('click', sendForm);

        function createInfoIcon(): string {
            if (settings.infoIconText) {
                return `<span id="modal-info-icon" class="icon-ico-info color-dark-green" data-toggle="tooltip" data-placement="right" title="${settings.infoIconText}"</span>`;
            }

            return '';
        }

        function sendForm() {
            $saveButton.prop('disabled', true);

            insertSpinnerToSaveButton();

            if (settings.onBeforeSubmit) {
                settings.onBeforeSubmit();
            }

            let $form: JQuery = $content.find('form');

            if (enableClientSideValidation && !$form.valid()) {
                resetSaveButtonStatus();
                return;
            }

            $.ajax({
                url: settings.saveUrl,
                data: $form.serialize(),
                headers: {
                    Accept: "application/json; charset=utf-8"
                },
                type: 'POST'
            })
                .done((data) => {
                    if (data && data.success) {
                        if (settings.closeModalWindowAfterSave !== false) {
                            closeGenericModal();
                        }

                        if (settings.callback) {
                            settings.callback(data);
                        }
                    }
                    else {
                        $errorWrapper.empty();

                        let str: string = "";

                        if ($.isArray(data.message)) {
                            for (let i = 0; i < data.message.length; ++i) {
                                str = data.message.join('<br />');
                            }
                        }
                        else {
                            str = data.message;
                        }

                        $errorWrapper.html(str);
                        $errorWrapper.show();
                    }
                })
                .fail((jqXHR) => {
                    $errorWrapper.empty();

                    if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
                        $errorWrapper.html(jqXHR.responseJSON.message);
                    }
                    else {
                        $errorWrapper.html(jqXHR.responseText);
                    }

                    $errorWrapper.show();
                })
                .always(() => {
                    resetSaveButtonStatus();
                });

            function insertSpinnerToSaveButton() {
                $saveButton.prepend('<span id="modal-save-button-spinner" class="spinner-border spinner-border-oeny mr-3" role="status" aria-hidden="true"></span>');
            }
        }

        // Everything is set up, show the popup
        // Do not auto-focus, it is placed in the first input field after load (since we are always loading forms as the content)
        $elem.modal({ focus: false });

        function resetSaveButtonStatus() {
            $('#modal-save-button-spinner').remove();
            $saveButton.prop('disabled', false);
        }
    }

    export function disableSaveButton() {
        $(saveButtonId).attr('disabled', 'disabled');
    }

    export function enableSaveButton() {
        $(saveButtonId).removeAttr('disabled');
        $(saveButtonId).children().remove();
    }

    export function closeGenericModal() {
        closeBootstrapSpecificModal('#generic-modal-form');
    }

    export function closeUploadModal() {
        closeBootstrapSpecificModal('#generic-modal-upload');
    }

    export function closeBootstrapSpecificModal(id: string) {
        let $modal: JQuery<HTMLElement> = $(id);

        $modal.removeClass('fade');
        $modal.modal('hide');
    }

    export function showErrorOnBootstrapModalWindow(errorText: string) {
        $('#form-modal-error').text(errorText).show();
    }

    function parseUnobtrusiveValidatorRules(selector: string, invalidHandler: any = null) {
        let uo: any = $.validator.unobtrusive

        let defaultOptions = uo.options;

        uo.options = {
            invalidHandler: invalidHandler
        };

        // Initialize the validation rules for the form (so the client side rules apply)
        $.validator.unobtrusive.parse(selector);

        uo.options = defaultOptions;
    }

    /**
     * Generating ajax bootstrap modal window with custom save & dismiss button logic
     * @param title
     * @param contentUrl
     * @param onSave
     * @param onDismiss
     */
    export function ShowBootstrapModalWithCustomContent(title: string, contentUrl: string, requestData: object, onSave: Function, onDismiss: Function) {
        var $elem = $('#generic-modal-form');
        var $title = $elem.find("#form-modal-title");
        var $content = $elem.find("#form-modal-content");
        var $saveButton = $('#form-modal-save');
        var $closeButton = $('#form-modal-close');
        var $dismissButton = $('#form-modal-reject');
        var $errorWrapper = $('#form-modal-error');

        // Reset the content
        $title.html(title);
        $content.html('');
        $content.html('<span class="icon-ico-refresh spinner text-center w-100"></span>');
        $errorWrapper.hide();

        // Load the content of the form
        $elem.off('show.bs.modal').on('show.bs.modal', function () {
            $content.load(contentUrl, requestData, function () {

                // Also handle the enter keypress to submit the form
                $content.find('form').keypress(function (event) {
                    if (event.keyCode === 13) {
                        event.preventDefault();
                        onSave();
                    }
                });

                // Try to focus the first input field, hoping for the best
                $content.find('form input:first').focus();
            });

        });

        $saveButton.off('click').on('click', () => { onSave(); });
        $closeButton.off('click').on('click', () => { onDismiss(); });
        $dismissButton.off('click').on('click', () => { onDismiss(); });

        // Everything is set up, show the popup
        // Do not auto-focus, it is placed in the first input field after load (since we are always loading forms as the content)
        $elem.modal({ focus: false });
    }

    export function FavoriteSettlementSettingsModal(contentUrl: string, userId: number): void {
        let $elem: JQuery = $('#settlement-filter-modal-settings-form');
        let $content: JQuery = $elem.find("#form-modal-content");
        let $saveButton: JQuery = $elem.find("#settlement-modal-save");
        let $errorWrapper: JQuery = $elem.find('#form-modal-error');

        // Reset the content
        $content.html('<span class="icon-ico-refresh spinner text-center w-100"></span>');
        $errorWrapper.hide();

        // Load the content of the form
        $elem.off('show.bs.modal').on('show.bs.modal', function (e) {
            $content.load(contentUrl, null, function () {
                // Also handle the enter keypress to submit the form
                $content.find('.modal-footer').keypress(function (event: JQuery.Event) {
                    if (event.keyCode === 13) {
                        event.preventDefault();
                        getSelectedValuesBeforeSend();
                    }
                });
            });
        });

        // When saving, we need to POST an ajax request
        $saveButton.off('click').on('click', getSelectedValuesBeforeSend);

        function getSelectedValuesBeforeSend() {
            let grid: MVCxClientGridView = window["SettlementAndTerritoryList"];
            grid.GetSelectedFieldValues("Id", gotSelectedValues);
        }

        function gotSelectedValues(values: string[]) {
            let selectedSettlementIds: Array<Number> = values.map(Number);
            send(selectedSettlementIds);
        }

        function send(selectedSettlementIds: Array<Number>) {
            $.ajax({
                url: window.ETDR_RD.appConfig['UrlAction.UpdateUsersFavoriteSettlements'],
                data: {
                    userId: userId,
                    favoriteSettlementIds: selectedSettlementIds
                },
                method: 'POST'
            })
                .done(function (data) {
                    if (data && data.success) {
                        $elem.modal('hide');
                        location.reload();
                    }
                    else {
                        $errorWrapper.empty();

                        let str: string;
                        if ($.isArray(data.message)) {
                            for (var i = 0; i < data.message.length; ++i) {
                                str = data.message.join('<br />');
                            }
                        }
                        else {
                            str = data.message;
                        }

                        $errorWrapper.html(str);
                        $errorWrapper.show();
                    }
                })
                .fail(function (jqXHR) {
                    $errorWrapper.html(jqXHR.responseText);
                    $errorWrapper.show();
                });
        }

        $elem.modal({ focus: false });
    }

    // Display a confirmation window before opening (navigating to or calling it via ajax) the link (or do nothing if the user selected cancel)
    // It expects the parameters (other than the actual element, the "this" param) in data-* attributes (so it can be configured purely from DOM elements)
    // data-href: This URL will be called when the user selects "yes"
    // data-confirm-message: The message promted to the user
    // data-is-ajax: Call it in the background or navigate (window.location) to the page (optional, default: false). data-oncomplete is ignored if this value is false
    // data-oncomplete: eval after the ajax call returned with success code (optional)
    //
    // Usage: <a href="#" onclick="return confirmBeforeSubmit(this)" data-href="/Process/ShowSomething?id=1234" data-confirm-message="Are you sure?">Link text</a>  - will navigate to the page
    //        <a href="#" onclick="return confirmBeforeSubmit(this)" data-href="/Process/DeleteSomething?id=1234" data-is-ajax="true" data-oncomplete="RefreshMyTable()" data-confirm-message="Are you sure?">Link text</a> - will be called in the background
    export function confirmBeforeSubmit(elem) {

        var $this = $(elem);

        var confirmMessage = $this.data('confirm-message');
        var onComplete = $this.data('oncomplete');
        var url = $this.data('href');
        var isAjax = $this.data('is-ajax');

        if (showConfirmationWindow(confirmMessage)) {

            if (isAjax) {
                $.ajax({
                    url: url,
                    complete: function () {
                        if (onComplete) {
                            eval(onComplete);
                        }
                    }
                });

                return true;
            }
            else {
                window.location.assign(url);

                return true;
            }
        }
        else {
            return false;
        }
    }

    export function ToggleModalSaveButtonStateByDxSelectionState(s: MVCxClientGridView, e) {
        const selectedKeys: number[] = s.GetSelectedKeysOnPage();
        const $saveButton: JQuery<HTMLElement> = $('#form-modal-save');

        if (selectedKeys.length == 0) {
            $saveButton.attr('disabled', 'disabled');
        } else {
            $saveButton.removeAttr('disabled');
        }
    }
}

export default Modal;
